import { render, staticRenderFns } from "./UpdateBikesMaintenances.vue?vue&type=template&id=8720a1e4&scoped=true&lang=pug&"
import script from "./UpdateBikesMaintenances.vue?vue&type=script&lang=js&"
export * from "./UpdateBikesMaintenances.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBikesMaintenances.vue?vue&type=style&index=0&id=8720a1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8720a1e4",
  null
  
)

export default component.exports